import { ObjectId } from './base';

export enum AlcoholMeasurementType {
  OUNCE = 'OUNCE',
  POUND = 'POUND',
  MILLILITER = 'MILLILITER',
  LITER = 'LITER',
  FLUID_OUNCE = 'FLUID_OUNCE',
  GALLON = 'GALLON',
}

export const AlcoholMeasurementTypeList = {
  [AlcoholMeasurementType.OUNCE]: 'Ounce',
  [AlcoholMeasurementType.POUND]: 'Pound',
  [AlcoholMeasurementType.MILLILITER]: 'Milliliter ',
  [AlcoholMeasurementType.LITER]: 'Liter',
  [AlcoholMeasurementType.FLUID_OUNCE]: 'Fluid Ounce',
  [AlcoholMeasurementType.GALLON]: 'Gallon',
} as const;

export interface IAlcoholBrand extends ObjectId {
  name: string;
}

export interface IAlcohol {
  brand?: IAlcoholBrand;
  quantity?: number | null;
  measurementType?: AlcoholMeasurementType | null;
}
